import { apiUri } from "../../../config";
import axios from "axios";
import { padCalendar } from "../../../util";

export const LOAD_ACE_ALERTS = 'LOAD_ACE_ALERTS';


const receivedPageOfAceAlerts = (alerts, page) => {
	const convertedAceAlerts = alerts.content.map(c => {
		c.riskAssessmentDate = padCalendar(c.riskAssessmentDate);
		return {
			companyName: c.companyName,
			riskAssessmentDate: c.riskAssessmentDate,
			ticker: c.symbol,
			id: c.id,
			alertId: c.alertId,
			status: c.status,
			sicCode: c.sicCode,
			cik: c.cik,
			enabled: c.enabled,
			identifier: c.identifier,
			caseFile: c.caseFile,
			market: c.market,
			indexListId: c.indexListId,
			notes: c.notes,
			firmId: c.firmId,
			lastUpdate: c.lastUpdate,
			dateAdded: c.dateAdded,
			dataURL: c.dataURL,
			newsURL: c.newsURL,
			s3URL: c.s3URL
		}
	}
	);
	return ({
		type: LOAD_ACE_ALERTS,
		aceAlert: convertedAceAlerts,
		totalAceAlerts: alerts.total,
		totalPages: alerts.totalPages,
		currentPage: page
	})
};

export const requestPageOfAceAlert = (page, sortKey='', sortOrder='') => {
	let search = JSON.parse(localStorage.getItem("searchValue")) || '';
	let sortData = JSON.parse(localStorage.getItem("sortParams"));
	if (sortData && sortData.sortValue && sortData.sortOrder) {
		sortKey = sortData.sortValue;
		sortOrder = sortData.sortOrder;
	}
	return dispatch => {
		axios.get(apiUri + "/alert/admin?page=" + page + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
			.then(json => {
				dispatch(receivedPageOfAceAlerts(json.data, page))
			})
			.catch(err => { console.log(err) })
	}
};


// WEBPACK FOOTER //
// ./src/components/Admin/storeAceAlerts/action.js